import { readJSONEnvionmentConfigData } from "@env/environement.loader";

export const environment = readJSONEnvionmentConfigData('dev');
